import React from 'react';
import { useQuery } from 'react-query';
import { isNotNil } from 'utils/ramdaUtils';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

interface Props<WrappedComponentProps, T> {
  WrappedComponent: React.FC<WrappedComponentProps>;
  fetchFunction: (id: string | number) => Promise<T>;
  queryKey: string[];
  Skeleton?: React.FC;
}

export const withFetcher =
  <
    WrappedComponentProps extends { data: T },
    T extends Record<any, any> = any
  >({
    WrappedComponent,
    fetchFunction,
    queryKey,
    Skeleton = DrawerFormSkeleton
  }: Props<WrappedComponentProps, T>) =>
  (props: { id?: string | number } & Omit<WrappedComponentProps, 'data'>) => {
    const { id, ...restProps } = props;

    const { data, isFetching } = useQuery({
      queryKey: [...queryKey, id],
      enabled: isNotNil(id),
      queryFn: () => fetchFunction(id ?? -1)
    });

    if (isFetching) {
      return <Skeleton />;
    }

    return (
      <WrappedComponent {...(restProps as WrappedComponentProps)} data={data} />
    );
  };
